import { Link } from "react-router-dom";
import { LOGO } from "@/constants/images";

const Footer = () => (
  <footer className="grain relative bg-forestdeep text-cream" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 py-16 sm:px-12 lg:py-20">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <div className="w-fit bg-cream px-4 py-3">
            <img
              src={LOGO}
              alt="Scottish Voice and Verse logo"
              data-testid="footer-logo-image"
              className="h-28 w-auto mix-blend-multiply sm:h-32"
            />
          </div>
          <p className="mt-5 text-sm tracking-[0.3em] text-gold" data-testid="footer-tagline">
            CEREMONY. STORY. VOICE.
          </p>
          <p className="mt-3 text-xs uppercase tracking-[0.22em] text-cream/60" data-testid="footer-celebrant-line">
            Karen Woods, Scottish Celebrant
          </p>
        </div>
        <div>
          <p className="mb-5 text-xs uppercase tracking-[0.25em] text-cream/60">Navigate</p>
          <div className="flex flex-col gap-3">
            {[
              { to: "/", label: "Home", id: "footer-home-link" },
              { to: "/ceremonies", label: "Ceremonies", id: "footer-ceremonies-link" },
              { to: "/pricing", label: "Pricing", id: "footer-pricing-link" },
              { to: "/about", label: "About", id: "footer-about-link" },
              { to: "/faq", label: "FAQ", id: "footer-faq-link" },
              { to: "/contact", label: "Contact", id: "footer-contact-link" },
            ].map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={l.id}
                className="w-fit text-sm text-cream/80 transition-colors duration-300 hover:text-gold"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <p className="mb-5 text-xs uppercase tracking-[0.25em] text-cream/60">Correspondence</p>
          <p className="text-sm text-cream/80" data-testid="footer-location">Alyth, Perthshire, Scotland</p>
          <a
            href="mailto:karenwoods@scottishvoiceandversecelebrancy.co.uk"
            data-testid="footer-email-link"
            className="mt-2 block w-fit text-sm text-gold transition-colors duration-300 hover:text-cream"
          >
            karenwoods@scottishvoiceandversecelebrancy.co.uk
          </a>
        </div>
      </div>
      <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-gold/25 pt-8 sm:flex-row sm:items-center">
        <p className="text-xs tracking-wide text-cream/50" data-testid="footer-copyright">
          Copyright 2026 Scottish Voice and Verse
        </p>
        <p className="font-display text-sm italic text-cream/50">Ceremony as it should be.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
